export const CAST_METHOD = 'cast'

export type CastMethod = 'airplay' | 'chromecast'
